<template   >
  <div class="combo-table" >
    <div class="combo-tr"   :key="key" v-for="(item, key) in list">
      <div class="combo-td combo-tr-title">{{item.title}}</div>
      <div class="combo-td">
        <template v-if="key === 'groupB'">
          <div class="am-g  am-padding-vertical-xs combo-essential am-flex " v-for="(item, key) in item.cells" :key="key">
            <div class="am-flex-num-2">
              <div class="am-button-custom active" :class="{ disabled: item.disabled}">
                <div class="am-inline-block">
                  <span>{{item.name}} </span>
                  <span class="am-padding-left-sm" v-if="item.hasStock&&!item.disabled">(库存：{{item.stockNum}})</span>
                  <span class="am-padding-left-sm" v-if="item.warnText">{{item.warnText}}</span>
                </div>
                <template v-if="item.property&&item.num>0">
                  <div class="am-inline-block  combo-additional-button" @click.prevent="initComboAdditional(item)">
                    <span>特殊要求</span>
                    <span v-if="item.num" class="prefix-price-unit">
                      {{currency}}{{item.totalProductPrice}}
                    </span>
                  </div>
                </template>
              </div>
            </div>
            <div class=" am-text-right ">
              <div class="am-button-custom">
                <span>{{item.num}}</span>份
              </div>
            </div>
          </div>
        </template>
        <template v-if="key === 'groupC'">
          <div v-for="(item, key) in item.items" :key="key" class="am-margin-top-sm">
            <p >{{item.title}}</p>
            <RadioGroup v-model="item.checkValue" @on-change="updateCombo" >
              <Radio :label="key"  v-for="(item, key) in item.cells" :key="key"  custom :disabled="item.disabled" class="am-margin-top-10 am-margin-right-20">
                <div slot-scope="{ currentValue }" class="am-button-custom " :class="{active: currentValue, disabled: item.disabled}">
                  <div class="am-inline-block">
                    <span>{{item.name}} 
                      {{(currentValue&&item.num>0&&item.price)?('¥'+item.price*item.num):''}}
                    </span>
                    <span v-if="item.hasStock&&!item.disabled" class="am-padding-left-sm" >(库存：{{item.stockNum}})</span>
                    <span class="am-padding-left-sm" v-if="item.warnText">{{item.warnText}}</span>
                  </div>
                  <template v-if="item.property&&currentValue&&item.num>0">
                    <div class="am-inline-block  combo-additional-button" @click.prevent="initComboAdditional(item)">
                      <span>特殊要求</span>
                      <span v-if="item.num" class="prefix-price-unit">
                        {{currency}}{{item.totalProductPrice-((item.price||0)*(item.num||0))|formatPrice}}
                      </span>
                    </div>
                  </template>
                </div>
              </Radio>
            </RadioGroup>
          </div>
        </template>
        <template v-if="key === 'groupD'">
          <div   v-for="(project, index) in item.items" :key="index">
            <div class=" am-margin-bottom-sm">
              <span >{{project.title}}</span>
              <span class="am-padding-left-sm am-color-price" v-if="project.maxNum>0">{{project.warnText}}</span>
            </div>
            <div class="am-flex am-flex-column-center am-padding-bottom-sm am-padding-horizontal-xs"  v-for="(product, key) in project.cells"  :key="key">
              <div class="combo-label" >
                <span>{{product.name}} </span>
                <span class=" am-padding-left-sm" v-if="product.hasStock&&!product.disabled">(库存：{{product.stockNum}})</span>
              </div>
              <template v-if="product.disabled">
                <div class="am-button-custom disabled am-button-custom " >
                  {{product.warnText}}
                </div>
              </template>
              <template v-else>
                <template  v-if="product.property">
                  <div class="  am-button-custom   am-margin-left-sm" :class="{disabled: product.forbiddenAdd}" >
                    <div class="am-inline-block">{{product.num}}份
                      {{product.num*(product.price||0)?'¥'+(product.num*(product.price||0)):''}}
                    </div>
                    <div class="am-inline-block  combo-additional-button" @click.prevent="initComboAdditional(product)"  >
                      <span>特殊要求</span>
                      <span v-if="product.num" class="prefix-price-unit">
                        {{currency}}{{(product.num&&product.price?product.totalProductPrice-(product.num*product.price):product.totalProductPrice)|formatPrice}}
                        </span>
                    </div>
                  </div>
                  <div class="am-margin-left-sm am-button-custom" @click="resetProductNum(product)" v-if="product.num">
                    重置
                  </div>
                </template>
                <template v-else>
                  <span v-if='product.num&&product.price' class='am-button-custom' style='margin-right:10px;'>{{'¥'+product.num*product.price}}</span>
                  <InputQuantity  v-model="product.num"  :max="product.buyMaxNum"  :min="product.buyMinNum" @on-change="updateCombo" class="combo-input-quantity"></InputQuantity>
                </template>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import InputQuantity from '@/components/InputQuantity/index'
  import Radio from '@/components/Radio/index'
  import RadioGroup from '@/components/RadioGroup/index'
  import CheckboxGroup from '@/components/CheckboxGroup/index'
  import Checkbox from '@/components/Checkbox/index'
  import { oneOf, indexOf, values, deepClone, each, find,formatPrice} from '@/utils/assist'

  export default {
    name: 'ComboGroup',
    props: {
      list: {
        type: [Object, Array]
      },
      combo: [Object, Array]
    },
    created () {
      this.$on('update', () => {
        this.$emit('updateCombo', this.combo)
      })
    },
    data() {
      return {
        currency: window.currency,
      }
    },
    mounted() {
    },
    computed: {},
    methods: {
      // 普通更新直接调用updateCombo 特殊要求更新initComboAdditional
      initComboAdditional (product) {
        this.$emit('initComboAdditional', product, this.combo._id)
      },
      updateCombo () {
        this.$emit('updateCombo', this.combo)
      },
      resetProductNum (product) {
        if (product.num) {
          product.num = 0;
          if (product._additional.list.length) {
            product._additional.list[0].num = 0;
          }
          this.updateCombo()
        }
      }
    },
    components: {
      InputQuantity,
      Radio,
      RadioGroup,
      CheckboxGroup,
      Checkbox
    },
    destroyed() {
    },
    filters: {
      formatPrice
    }
  }
</script>

<style scoped>
  .combo-input-quantity {
    width: 100px
  }
</style>



// WEBPACK FOOTER //
// components/business/ComboGroup/ComboGroup.vue